import { Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, TemplateRef, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { IConditionVariable } from '../../../../redux/timeline-data.model';
import { BbRadioListOption } from '../../../../../bb-radio-list/bb-radio-list.component';
import { InteractivityActionService } from '../../../../../../../components/shared/interactivity-editor/services/interactivity-action.service';
import { InteractivityEditorService } from '../../../../../../../components/shared/interactivity-editor/services/interactivity-editor.service';
import { InteractivityDataSourceService } from '../../../../../../../components/shared/interactivity-editor/services/interactivity-data-source.service';
import { OverlayService } from '../../../../../../../services/overlay.service';

type ValueType = 'string' | 'boolean' | 'number';
@Component({
	selector: 'condition-variable',
	templateUrl: './condition-variable.component.html',
	styleUrls: ['./condition-variable.component.scss']
})

export class ConditionVariableComponent implements OnInit, OnChanges, OnDestroy {

	@Input() conditionVariable: IConditionVariable;
	@Output() delete: EventEmitter<IConditionVariable>;
	@Output() conditionVariableChanged: EventEmitter<null>;
	@ViewChild('dataSourceTemplate', { static: true }) dataSourceTemplate: TemplateRef<any>;
	operatorList: any[];
	selectedOperatorOption: any;
	selectedOperator: string;
	radioOptions: BbRadioListOption[] = [
		{
			label: 'Visible',
			icon: '',
			value: '=='
		},
		{
			label: 'Hidden',
			icon: '',
			value: '!='
		}
	];
	selectedRadioOption: BbRadioListOption;
	selectorOptions: any = {};
	widgetPropertySelectorConfig: any;
	currentType: ValueType = 'string';

	constructor(
		private actionService: InteractivityActionService,
		private interactivityEditorService: InteractivityEditorService,
		protected overlayService: OverlayService,
		public dataSourceService: InteractivityDataSourceService
	) {
		this.delete = new EventEmitter<IConditionVariable>();
		this.conditionVariableChanged = new EventEmitter<null>();
		this.operatorList = this.interactivityEditorService.operatorList;
	}

	ngOnInit() {
		this.updateSelectedOperatorOption();
		this.updateSelectedRadioOption();
		this.updateSelectorConfigs();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.conditionVariable &&
			((changes.conditionVariable.previousValue && changes.conditionVariable.currentValue) &&
				changes.conditionVariable.previousValue.rule.operator !== changes.conditionVariable.currentValue.rule.operator
			)
		) {
			this.updateSelectedOperatorOption();
			this.updateSelectedRadioOption();
		}
	}

	ngOnDestroy() {
	}

	updateSelectorConfigs() {
		this.selectorOptions.widget = this.interactivityEditorService.widgetsAsOptions;
		this.selectorOptions.chapters = this.interactivityEditorService.widgetsAsOptions.filter(w => w && w.type === 'chapter');
		this.selectorOptions.widgetProperties = this.actionService.getWidgetPropOptions();

		this.selectorOptions.player = this.actionService.getPlayerStateOptions();
		this.selectorOptions.localstorage = this.interactivityEditorService.localstorageKeys.map(v => ({ label: v, value: v }));
		this.selectorOptions.localstorage = this.interactivityEditorService.localstorageKeys.map(v => ({ label: v, value: v }));
		this.selectorOptions.localstorageValues = this.interactivityEditorService.localstorageValues.map(v => ({ label: v, value: v }));
		this.selectorOptions.variables = this.interactivityEditorService.variableOptions.map(v => ({ label: v, value: v }));
	}

	setOptions(category: 'player') {
		if (category === 'player') {
			const selected = this.selectorOptions.player.find((option: any) => this.conditionVariable.rule.lvalue === option.value);
			if (selected && selected.type) {
				this.updateType(selected.type);
			}
		}
	}

	updateType(type: ValueType) {
		this.currentType = type;
		switch (type) {
			default:
				this.operatorList = this.interactivityEditorService.operatorList.filter(option => option.value === '==' || option.value === '!=');
				break;

			case 'boolean':
				this.operatorList = [];
				this.conditionVariable.rule.operator = '==';
				this.conditionVariable.rule.rvalue = 'true';
				this.radioOptions = [
					{
						label: 'True',
						icon: '',
						value: '=='
					},
					{
						label: 'False',
						icon: '',
						value: '!='
					}
				];
				break;

			case 'number':
				this.conditionVariable.rule.rvalue = '';
				this.operatorList = this.interactivityEditorService.operatorList;
				break;
		}
	}

	onRadioChange(radioValue: string) {
		this.selectedRadioOption = this.radioOptions.find(option => option.value === radioValue);
		this.conditionVariable.rule.operator = this.selectedRadioOption.value;
		this.conditionVariable.rule.rvalue = 'true'; // ensure we've got an rvalue
		this.dispatchChange();
	}

	onDataSourceChanged(): void {
		this.dispatchChange();
	}

	onContentChange() {
		this.dispatchChange();
	}

	updateSelectedRadioOption() {
		this.selectedRadioOption = this.radioOptions.find(radioOption => radioOption.value === this.conditionVariable.rule.operator);
	}

	updateSelectedOperatorOption() {
		this.selectedOperatorOption = this.interactivityEditorService.operatorList.find(operator => operator.value === this.conditionVariable.rule.operator);
		this.selectedOperator = this.conditionVariable.rule.operator;
	}


	switchOperator(operatorOption: any) {
		this.selectedOperatorOption = operatorOption;
		this.conditionVariable.rule.operator = operatorOption.value;
		this.conditionVariableChanged.emit(null);
	}

	deleteConditionVariable(): void {
		this.delete.emit(this.conditionVariable);
	}

	private dispatchChange(): void {
		this.conditionVariableChanged.emit(null);
	}
}
